import React from "react";

import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import type { ErrorModalButtonType } from "@app/helpers/api-error";
import { useAppContext } from "@app/helpers/hooks";

import type { Dispatch } from "@reduxjs/toolkit";

import { closeModal } from "../../../store/state/modals";
import { clickedDeletePassenger } from "../../../tracking/account-tracking";
import { AlertDialog } from "../../alert-dialog";

interface Props {
  onConfirm: () => void;
}

interface ReduxProps {
  closeModal: () => void;
}

const DeletePassengerComponent: React.FC<ReduxProps & Props> = ({
  onConfirm,
  closeModal
}) => {
  const { tracker, translator } = useAppContext();

  const onAction = (button_type: ErrorModalButtonType) => {
    closeModal();

    if (button_type === "cta") {
      tracker.track(clickedDeletePassenger());
      onConfirm();
    }
  };

  return (
    <AlertDialog
      title={translator.t("!accounts.passengers.delete-passenger.title")}
      message={translator.t("!accounts.passengers.delete-passenger.message")}
      actionHandler={onAction}
      cta_button={{
        label: translator.t("!accounts.passengers.delete-passenger.cta")
      }}
      secondary_button={{
        label: translator.t("!accounts.passengers.delete-passenger.cancel")
      }}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ closeModal }, dispatch);

export const DeletePassenger = connect(
  () => ({}),
  mapDispatchToProps
)(DeletePassengerComponent);
